"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleDrawerSubitemsContainer_1 = require("./RawExampleDrawerSubitemsContainer");
var ContentExampleDrawerSubitemsContainer_1 = require("./ContentExampleDrawerSubitemsContainer");
var PropertiesDrawerSubitemsContainer_1 = require("./PropertiesDrawerSubitemsContainer");
exports.ComponentDrawerSubitemsContainerPage = function () { return (React.createElement(common_1.Page, { headerText: "Drawer Subitems Container" },
    React.createElement(common_1.Paragraph, null, "Drawer Subitems Container is a drawer item that expands to reveal others subitems."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleDrawerSubitemsContainer_1.RawExampleDrawerSubitemsContainer, null),
    React.createElement(ContentExampleDrawerSubitemsContainer_1.ContentExampleDrawerSubitemsContainer, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesDrawerSubitemsContainer_1.PropertiesDrawerSubitemsContainer, null))); };
exports.ComponentDrawerSubitemsContainerPage.displayName = 'ComponentDrawerSubitemsContainerPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerSubitemsContainerPage/ComponentDrawerSubitemsContainerPage.tsx
// module id = 663
// module chunks = 0